import apiProductRecall from '@/api/productRecall';
import apiOption from '@/api/option';

const defaultState = () => ({
	productRecallResults: [],
	productRecallPagination: '',
	responSukses: '',
	konfirmResponse: {},
	alert: '',
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	listProduct: [],
	detailApprovalproductRecall: {},
});

const state = defaultState();

const getters = {
	listProductNotSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == false
		})
	},
	listProductSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == true
		})
	},
};

const mutations = {
	listProductRecall(state, data) {
		state.productRecallResults = data.data
		state.productRecallPagination = data.pagination;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataApprovalRecall(state){
		Object.assign(state, defaultState())
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.selected = false
			el.quantity = '1'
			return el
		});
	},
	setDetailApprovalproductRecall(state, data){
		state.detailApprovalproductRecall = data
	}
};

const actions = {
	getDataProductRecall({ commit }, params) {
		apiProductRecall.getDataProductRecall(params).then(({ data: { data } }) => {
			commit('listProductRecall', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listProductRecall', { data: [], pagination: {} } );
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	async approveProductRecall({ commit, dispatch }, params) {
		await apiProductRecall.approveProductRecall(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal approval produk recall'
			}, { root: true });
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getProductAvailableToRecall().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	async detailProductRecall({ commit }, params) {
		await apiProductRecall.detailProductRecall(params).then( res => {
			const data = res.data;
			commit("setDetailApprovalproductRecall", data)
		}).catch(err => {
			const data = err.response.data
			commit("setDetailApprovalproductRecall", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};